import { useState } from 'react';
import { useQuery } from 'urql';
import PageHeader from '@/components/common/PageHeader.jsx';
import Field from '@/components/common/Field.jsx';
import StickyActions from '@/components/common/StickyActions.jsx';
import EmptyState from '@/components/common/EmptyState.jsx';
import { PORTAL_MIS_ENVIOS } from './gql.js';

export default function PortalEnviosPage() {
  const [filters, setFilters] = useState({ clienteId: '', estado: '', search: '' });
  const [submitted, setSubmitted] = useState(null);
  const [{ data, fetching }] = useQuery({
    query: PORTAL_MIS_ENVIOS,
    variables: submitted ?? undefined,
    pause: !submitted?.clienteId,
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!filters.clienteId) {
      alert('Ingresá el cliente');
      return;
    }
    setSubmitted({
      clienteId: filters.clienteId,
      estado: filters.estado || null,
      search: filters.search || null,
      fechaDesde: null,
      fechaHasta: null,
    });
  };

  const envios = data?.portalMisEnvios ?? [];

  return (
    <div className="w-full">
      <PageHeader title="Mis envíos" subtitle="Seguimiento de hitos y estados recientes" />
      <form onSubmit={handleSubmit} className="mx-auto mt-6 grid w-full max-w-[900px] grid-cols-12 gap-4">
        <div className="col-span-12 sm:col-span-4">
          <Field label="Cliente" htmlFor="clienteId" required>
            <input
              id="clienteId"
              type="number"
              value={filters.clienteId}
              onChange={event => setFilters(prev => ({ ...prev, clienteId: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
        </div>
        <div className="col-span-12 sm:col-span-4">
          <Field label="Estado" htmlFor="estado">
            <input
              id="estado"
              value={filters.estado}
              onChange={event => setFilters(prev => ({ ...prev, estado: event.target.value }))}
              placeholder="Ej: entregado"
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
        </div>
        <div className="col-span-12 sm:col-span-4">
          <Field label="Buscar" htmlFor="search">
            <input
              id="search"
              value={filters.search}
              onChange={event => setFilters(prev => ({ ...prev, search: event.target.value }))}
              placeholder="ID o detalle"
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
        </div>
        <div className="col-span-12 flex justify-end">
          <button
            type="submit"
            className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-semibold text-white shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Consultar
          </button>
        </div>
      </form>

      <section className="mx-auto mt-6 w-full max-w-[900px] rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.98)] p-6 shadow-xl">
        {fetching ? (
          <p className="text-sm text-[rgba(var(--muted),0.9)]">Buscando envíos...</p>
        ) : envios.length === 0 ? (
          <EmptyState title="Sin envíos" description="Ingresá un cliente para visualizar la trazabilidad." />
        ) : (
          <ul className="space-y-4">
            {envios.map(envio => (
              <li key={`${envio.referenciaTipo}-${envio.referenciaId}`} className="rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] p-4 text-sm text-[rgb(var(--fg))]">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-semibold">
                    {envio.referenciaTipo} #{envio.referenciaId}
                  </span>
                  <span className="text-xs text-[rgba(var(--muted),0.9)]">{envio.ultimoEventoEn ? new Date(envio.ultimoEventoEn).toLocaleString() : '—'}</span>
                </div>
                <p className="mt-2 text-xs uppercase tracking-wide text-[rgba(var(--muted),0.9)]">Estado: {envio.ultimoEstado}</p>
                {envio.ultimoDetalle ? (
                  <p className="mt-1 text-sm text-[rgba(var(--muted),0.95)]">{envio.ultimoDetalle}</p>
                ) : null}
                <div className="mt-3 space-y-2">
                  {envio.eventos.slice(0, 3).map(evento => (
                    <div key={evento.id} className="rounded-lg border border-[rgba(var(--border),0.4)] bg-[rgba(var(--panel),0.9)] px-3 py-2 text-xs text-[rgba(var(--muted),0.9)]">
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-[rgb(var(--fg))]">{evento.estado}</span>
                        <time>{new Date(evento.fechaHora).toLocaleString()}</time>
                      </div>
                      {evento.detalle ? <p className="mt-1">{evento.detalle}</p> : null}
                    </div>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        )}
      </section>

      <StickyActions>
        <span className="text-xs text-[rgba(var(--muted),0.9)]">
          Vista cliente — datos solo lectura
        </span>
      </StickyActions>
    </div>
  );
}
